import type { MutationHookOptions } from '@apollo/client'
import {
  CreateTrainingRelatorioUnicoFieldDocument,
  CreateTrainingRelatorioUnicoFieldMutation,
  CreateTrainingRelatorioUnicoFieldMutationVariables,
  EditTrainingQueryDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  CreateTrainingRelatorioUnicoFieldMutation,
  CreateTrainingRelatorioUnicoFieldMutationVariables
>

export const useCreateTrainingRelatorioUnicoField = (options?: Options) => {
  const [createTrainingRelatorioUnicoField, { loading }] = useMutation(
    CreateTrainingRelatorioUnicoFieldDocument,
    {
      ...options,
      extractorFn: (data) => data.trainingsMutations.createTrainingsTrainingRelatorioUnicoField,
    }
  )

  return {
    loading,
    create(variables: CreateTrainingRelatorioUnicoFieldMutationVariables) {
      return createTrainingRelatorioUnicoField({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [EditTrainingQueryDocument],
      })
    },
  }
}
